import { render, staticRenderFns } from "./VersionDiffShow.vue?vue&type=template&id=49b3a731&scoped=true&"
import script from "./VersionDiffShow.vue?vue&type=script&lang=js&"
export * from "./VersionDiffShow.vue?vue&type=script&lang=js&"
import style0 from "./VersionDiffShow.vue?vue&type=style&index=0&id=49b3a731&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b3a731",
  null
  
)

export default component.exports